import { assertNever } from '@kofno/piper';
import GroupStore from '.';
import ReactionComponent, { RCProps } from '../ReactionComponent';
import { loading } from './Loading';
import { State } from './Types';
import { createUserGroup } from './createUserGroup';

interface Props extends RCProps<GroupStore> {}

class AddEditUserGroupNewReactions extends ReactionComponent<GroupStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'loading':
        loading(store);
        break;
      case 'creating':
        createUserGroup(store, state);
        break;
      case 'newing':
      case 'waiting':
      case 'success':
      case 'add-participants':
      case 'load-error':
      case 'form-submission-error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default AddEditUserGroupNewReactions;
